import { Theme } from "@mui/material";
import { height, width } from "@mui/system";

export const SizeStyles = (theme: Theme) => {
  return {
    xxs: {
      width: "10px",
      height: "10px",
    },
    xs: {
      width: "16px",
      height: "16px",
    },
    sm: {
      width: "20px",
      height: "20px",
    },
    md: {
      width: "24px",
      height: "24px",
    },
    lg: {
      width: "32px",
      height: "32px",
    },
    xl: {
      width: "54px",
      height: "54px",
    },
    "2xl": {
      width: "72px",
      height: "72px",
    },
    "3xl": {
      width: "144px",
      height: "144px"
    }
  };
};